"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSameMeasure = exports.isCompleteMeasures = exports.deserializePileHistoryItem = exports.serializePileHistoryItem = exports.fillObjectKeys = exports.forEachArrayInObject = exports.groupObjectsByProperties = exports.groupObjectsByProperty = exports.uniqueValues = exports.sum = void 0;
function sum(t, i) {
    return t + i;
}
exports.sum = sum;
function uniqueValues(value, index, self) {
    return self.indexOf(value) === index;
}
exports.uniqueValues = uniqueValues;
function groupObjectsByProperty(objects, prop) {
    return objects.reduce((grouped, object) => {
        if (!grouped[object[prop]]) {
            grouped[object[prop]] = [];
        }
        grouped[object[prop]].push(object);
        return grouped;
    }, {});
}
exports.groupObjectsByProperty = groupObjectsByProperty;
function groupObjectsByProperties(objects, props) {
    const firstProp = props.shift();
    if (!firstProp)
        return objects;
    const grouped = groupObjectsByProperty(objects, firstProp);
    Object.keys(grouped).forEach((key) => {
        grouped[key] = groupObjectsByProperties(grouped[key], [...props]);
    });
    return grouped;
}
exports.groupObjectsByProperties = groupObjectsByProperties;
function forEachArrayInObject(object, fn) {
    if (Array.isArray(object)) {
        return fn(object);
    }
    else if (typeof object == 'object') {
        return Object.keys(object).reduce((result, key) => {
            result[key] = forEachArrayInObject(object[key], fn);
            return result;
        }, object);
    }
    return object;
}
exports.forEachArrayInObject = forEachArrayInObject;
function findMostKeys(entries) {
    return entries.reduce((most, entry) => {
        if (Object.keys(entry[1]).length > most.length)
            return Object.keys(entry[1]);
        return most;
    });
}
function findNestedObjectWithMostKeys(object, depth) {
    let current = object;
    for (let i = 0; i < depth - 1; i++) {
        let keys = Object.keys(current);
        let objectWithMostKeys = {};
        for (const key of keys) {
            let currentKeys = Object.keys(current[key]);
            if (currentKeys.length > Object.keys(objectWithMostKeys).length) {
                objectWithMostKeys = current[key];
            }
        }
        current = objectWithMostKeys;
    }
    return current;
}
function modifyObjectAtDepth(object, depth, fn, currentDepth = 0) {
    return Object.entries(object).reduce((o, entry) => {
        let [k, v] = entry;
        if (currentDepth == depth) {
            o[k] = fn(v);
            return o;
        }
        else {
            o[k] = modifyObjectAtDepth(object[k], depth - 1, fn, currentDepth + 1);
        }
        return o;
    }, {});
}
function fillObjectKeys(object, depth, defaultValue) {
    let nestedObjectWithMostKeys = findNestedObjectWithMostKeys(object, depth);
    modifyObjectAtDepth(object, depth - 1, (v) => {
        return Object.keys(nestedObjectWithMostKeys).reduce((o, k) => {
            if (!v[k]) {
                v[k] = defaultValue;
            }
            return o;
        }, v);
    });
    return object;
}
exports.fillObjectKeys = fillObjectKeys;
function serializePileHistoryItem(item) {
    const { road = '', team = '', foreman = '', essence = { name: '', code: '' }, measures = { length: '', heights: [], logLength: '' }, position = { latitude: '', longitude: '' }, created = '', modified = '', transported = '', status = '' } = item.toJSON();
    const { length, heights, logLength } = measures;
    const measureString = `${length || ''}:${logLength || ''}:${heights.join(',')}`;
    const positionString = `${position.latitude || ''}:${position.longitude || ''}`;
    const parts = [
        new Date().toISOString(),
        `${essence.name}:${essence.code}`,
        road, team, foreman, measureString,
        positionString,
        created ? new Date(created).getTime() : created,
        modified ? new Date(modified).getTime() : modified,
        transported ? new Date(transported).getTime() : transported,
        status
    ];
    return parts.join('|');
}
exports.serializePileHistoryItem = serializePileHistoryItem;
function deserializePileHistoryItem(item) {
    if (typeof item !== 'string')
        return item;
    const [snapshot, essence, road, team, foreman, measures, position, created, modified, transported, status] = item.split('|');
    const measureObject = {
        length: measures.slice(0, measures.indexOf(':')),
        logLength: measures.slice(measures.indexOf(':') + 1, measures.lastIndexOf(':')),
        heights: measures.slice(measures.lastIndexOf(':') + 1).split(',').filter(n => !!n),
    };
    if (!isNaN(measureObject.length)) {
        measureObject.length = Number(measureObject.length);
    }
    if (!isNaN(measureObject.logLength)) {
        measureObject.logLength = Number(measureObject.logLength);
    }
    if (measureObject.heights.length > 0) {
        measureObject.heights = measureObject.heights.map((n) => {
            return Number(n);
        });
    }
    const positionObject = {
        latitude: position.slice(0, position.indexOf(':')) || undefined,
        longitude: position.slice(position.indexOf(':') + 1) || undefined
    };
    if (!isNaN(positionObject.latitude)) {
        positionObject.latitude = Number(positionObject.latitude);
    }
    if (!isNaN(positionObject.longitude)) {
        positionObject.longitude = Number(positionObject.longitude);
    }
    return {
        snapshot: snapshot,
        essence: { name: essence.slice(0, essence.indexOf(':')), code: essence.slice(essence.indexOf(':') + 1) },
        road: road ? road : undefined,
        team: team ? team : undefined,
        foreman: foreman ? foreman : undefined,
        measures: measureObject,
        position: positionObject,
        created: created !== '' ? new Date(Number(created)) : undefined,
        modified: modified !== '' ? new Date(Number(modified)) : undefined,
        transported: transported !== '' ? new Date(Number(transported)) : undefined,
        status: status ? status : undefined
    };
}
exports.deserializePileHistoryItem = deserializePileHistoryItem;
function isCompleteMeasures(measures) {
    if (!measures)
        return false;
    let hasLength = !isNaN(measures.length) && measures.length > 0;
    let hasWidth = !isNaN(measures.logLength) && measures.logLength > 0;
    let hasHeight = Array.isArray(measures.heights) && measures.heights.length > 0;
    return hasLength && hasWidth && hasHeight;
}
exports.isCompleteMeasures = isCompleteMeasures;
function isSameMeasure(measureA, measureB) {
    let a = measureA.length * measureA.logLength * (measureA.heights.length ? measureA.heights.reduce(sum) : 0);
    let b = measureB.length * measureB.logLength * (measureB.heights.length ? measureB.heights.reduce(sum) : 0);
    return a === b;
}
exports.isSameMeasure = isSameMeasure;
